
import { Component, Mixins } from "vue-property-decorator";
import { ILinkedScriptExecuteBehavior, ILinkedObjectSpecifiable } from "../../../../../../documaker/domain/format/objects";
import { IScriptExecuteBehaviorPropertyEditable, instanceOfIScriptExecuteBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class ScriptExecuteBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IScriptExecuteBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IScriptExecuteBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isScriptExecuteBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIScriptExecuteBehaviorPropertyEditable(s) && s.scriptExecuteBehavior().isEditable(), false);
  }

  get scriptExecuteBehavior(): ILinkedScriptExecuteBehavior {
    return this.readPropertyOrDefault(
      s => s.scriptExecuteBehavior().getValue(),
      {
        timing: 0,
        scriptPath: "",
        separator: "",
        parameters: [],
        csvFilePathFormat: "",
        valuesXmlPathFormat: "",
        previousValuesCsvFilePathFormat: "",
        references: [],
      });
  }

  set scriptExecuteBehavior(value: ILinkedScriptExecuteBehavior) {
    this.writePropertyWhenValid(s => s.scriptExecuteBehavior().setValue(value));
  }

  get linkedObjectIdentifier(): ILinkedObjectSpecifiable {
    return this.readPropertyOrDefault(s => s.toLinkedObjectIdentifier(), { type: "", id: null, key: "" });
  }
}
